export default {
    setLocale(state, locale) {
        state.app_locale = locale;
    }
}
